module.exports = __webpack_public_path__ + "img/SanDisplay.c114540e.png";